export enum ImageComponentNames {
  stylingLargeImage = "stylingLargeImage",
  stylingNormalImage = "stylingNormalImage",
  stylingCarousel = "stylingCarousel",
  stylingUserImage = "stylingUserImage",
  stylingUserNormalImage = "stylingUserNormalImage",
  stylingUserSmallImage = "stylingUserSmallImage"
}

interface ImageComponentMap {
  [name: string]: any;
}

export const ImageWidthByComponent: ImageComponentMap = {
  stylingLargeImage: {
    mobile: "r-480-640",
    tablet: "r-480-640",
    pc: "r-480-640"
  },
  stylingNormalImage: {
    mobile: "r-480-640",
    tablet: "r-480-640",
    pc: "r-300-400"
  },
  stylingCarousel: {
    mobile: "r-600-800",
    tablet: "r-920-1227",
    pc: "r-500-667"
  },
  stylingUserImage: {
    mobile: "c-240-240",
    tablet: "c-240-240",
    pc: "c-240-240"
  },
  stylingUserNormalImage: {
    mobile: "c-120-120",
    tablet: "c-120-120",
    pc: "c-120-120"
  },
  stylingUserSmallImage: {
    mobile: "c-90-90",
    tablet: "c-90-90",
    pc: "c-90-90"
  }
};

const mqMediumScreenMinWidthLimit = 600;
const mqLargeScreenMinWidthLimit = 960;
const isClient = typeof window !== "undefined";

// get device type by window width
export function getDeviceType() {
  if (isClient) {
    const width: number = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );
    if (width < mqMediumScreenMinWidthLimit) {
      return "mobile";
    } else if (width < mqLargeScreenMinWidthLimit) {
      return "tablet";
    }
    return "pc";
  } else {
    return "mobile";
  }
}

export function hasImgSuffix(url: string) {
  return /\.(jpg|jpeg|png|webp|avif|gif)$/.test(url);
}

export function optimizedUGCImageUrlByDevice(
  imageUrl: string,
  imageComponent: string
): string {
  if (imageUrl === "") return imageUrl;
  const deviceType = getDeviceType();
  const widthParam = ImageWidthByComponent[imageComponent][deviceType];
  return !hasImgSuffix(imageUrl) ? `${imageUrl}_${widthParam}` : imageUrl;
}
